import { HttpPrefixerService } from './httpPrefixer.service';

export const HttpPrefixDirective = angular
    .module('app.components.httpPrefix.vlnHttpPrefix', [
        HttpPrefixerService
    ]).directive('vlnHttpPrefix', (httpPrefixer) => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, elem, attrs, ngModelCtrl) => {
                let forceHttps = attrs.forceHttps;
                function ensureHttpPrefix(value) {
                    if (value) {
                        let viewValue = httpPrefixer.prefixUrl(value, forceHttps);
                        ngModelCtrl.$setViewValue(viewValue);
                        ngModelCtrl.$render();
                        return viewValue;
                    }

                    return value;
                }

                ngModelCtrl.$formatters.push(ensureHttpPrefix);
                ngModelCtrl.$parsers.splice(0, 0, ensureHttpPrefix);
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/httpPrefix/httpPrefix.directive.js